exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "fieldset .row[data-v-5b0b94a6]:first-child{margin-top:20px}", ""]);

// exports
